module.exports = __webpack_public_path__ + "img/autopay1.77b8de17.svg";